import React from 'react';
import PropTypes from 'prop-types';

import SaveIcon from '@material-ui/icons/SaveAlt';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function DownloadLink(props) {
  const { classes, label, action } = props;

  return (
    <a
      className={classes.root}
      href='#'
      onClick={(e) => {
        action();
        e.preventDefault();
      }}
    >
      <SaveIcon className={classes.downloadIcon} /> {label}
    </a>
  );
}

DownloadLink.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
};

export default withStyles(styles)(DownloadLink);
